import { makeStyles } from 'tss-react/mui';

const useStylesFieldTextRich: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  containerFieldTextRichBordered: {
    borderTop: `1px solid ${theme.palette.info.main}`,
  },
  containerFieldTextRichInline: {
    '& > div > div:last-of-type > div': {
      minHeight: 50,
    },
  },
  containerFullWidth: {
    width: '100%',
  },
  fieldTextRich: {
    width: '100%',
    height: 150,
  },
  error: {
    color: `${theme.palette.error.main} !important`,
    fontWeight: 'normal',
    padding: '3px 0',
    '&:empty': {
      display: 'none',
    },
  },
}));

export default useStylesFieldTextRich;
